import React, { useState } from 'react'
import Select from 'react-select';
import { useQuery } from 'react-query';
import { ApiHttpService } from 'cms/utils/http/api';
import { makeDarkSelectStyles, withMenuPortal } from 'cms/components/selectStyles';

export default function SelectUserGalleryCategory({ callback, value, width , placeholder, menuPortal }) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const customStyles = withMenuPortal(
        makeDarkSelectStyles({
            width: width || '220px',
            border: true,
        })
    );

    useQuery('videoGallerycategories', () =>
    ApiHttpService.loadUserGalleryCategories(),
    {
      onSuccess: (data) => {
        if (data.results) {
            _setData(data.results)
        }
      },
    }
  );

    const _setData = (categories)=>{
        if (categories.detail) return;

            if (categories) {
                var temp = []
                var temp_options = []

                categories.map((item, i) => {
                    //var t = userTalents.find(x => x.talent.id === item.id)

                    temp.push(item)

                    var option = null;

                   
                        option = {
                            label:
                            item.title ,
                            value: item.id
                        }

                    temp_options.push(option)

                })
                //
                setSelectOptions(temp_options);
                // callback()
                //setTalents(temp)
            }

    }

    const handleSelect = (e) => {

        callback(e && e.value, "category")
        

    }

    return (
        <>
            <div className="filter-select">
                <Select
                    options={SelectOptions}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder ? placeholder : "Category"}
                    isClearable={true}
                    value={SelectOptions && (SelectOptions.find(obj => obj.value == value) || null)}
                    menuPortalTarget={menuPortal && typeof document !== 'undefined' ? document.body : undefined}
                    menuPosition={menuPortal ? 'fixed' : undefined}
                />
            </div>
            
        </>
    )
}
